import type { Stripe } from '@stripe/stripe-js';
import { PaymentMethodEnum, ProviderEnum } from '@/types/common';
import type { PaymentKeys, PaymentMethod } from '@/types/checkout';
import { stripeService } from '@/services/stripe';
import { loadStripeResilient } from '@/utils/stripeLoader';
import { getPaymentKey } from '@/utils/getPaymentKey';

export const resolveStripeFor3DS = async (
  paymentMethod: PaymentMethodEnum | undefined,
  fallback: Stripe | null | undefined,
  paymentMethodsSettings: PaymentMethod[],
  paymentKeys: PaymentKeys
) => {
  const isWallet = paymentMethod === PaymentMethodEnum.GOOGLE_PAY || paymentMethod === PaymentMethodEnum.APPLE_PAY;
  return isWallet ? getWalletStripe(fallback) : loadCardStripe(fallback, paymentMethodsSettings, paymentKeys);
};

const getWalletStripe = (fallback: Stripe | null | undefined): Stripe | null | undefined => {
  try {
    return stripeService.getStripeExpress();
  } catch {
    return fallback;
  }
};

const loadCardStripe = async (
  fallback: Stripe | null | undefined,
  paymentMethodsSettings: PaymentMethod[],
  paymentKeys: PaymentKeys
): Promise<Stripe | null | undefined> => {
  const cardMethod = paymentMethodsSettings.find(
    (pm) => pm.provider === ProviderEnum.STRIPE && pm.paymentMethodName === PaymentMethodEnum.CREDIT_CARD
  );
  const cardPk = getPaymentKey(cardMethod?.pspSubMidPk, paymentKeys.stripe, {
    provider: ProviderEnum.STRIPE,
    paymentMethod: PaymentMethodEnum.CREDIT_CARD,
  });
  if (!cardPk) return fallback;

  return (await loadStripeResilient(cardPk)) ?? fallback;
};
